import React, { useEffect, useState } from 'react';
import { translate } from '../../Services/translation';
import {
  StyledSizeGuideContainer,
  StyledSizeGuideMenu,
  StyledSizeGuideTrigger,
} from './styles/SizeGuideContainer.styling';

const SizeGuideContainer = ({ SizeGuide }: any) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [sizeGuideContainerRef, setSizeGuideContainerRef] = useState<
    HTMLDivElement | undefined
  >();
  const [children, setChildren] = useState<Element[]>([]);

  useEffect(() => {
    if (!modalOpen) {
      setSizeGuideContainerRef(undefined);
    }
  }, [modalOpen]);

  useEffect(() => {
    const sizeGuideElem = document.getElementById('size-guide-content');
    setChildren(Array.from(sizeGuideElem?.children ?? []));
  }, []);

  useEffect(() => {
    if (sizeGuideContainerRef) {
      sizeGuideContainerRef.innerHTML = '';
      for (var child of children) {
        sizeGuideContainerRef.appendChild(child);
      }
    }
  }, [sizeGuideContainerRef, children]);

  return (
    <>
      <StyledSizeGuideTrigger onClick={() => setModalOpen(!modalOpen)}>
        {translate('size-guide.trigger-button')}
      </StyledSizeGuideTrigger>
      <StyledSizeGuideMenu
        id="sizeGuide"
        className="size-guide-side-menu"
        title={translate('size-guide.title')}
        open={modalOpen}
        onClosed={() => setModalOpen(false)}
      >
        <StyledSizeGuideContainer
          ref={(ref) => {
            if (ref) {
              setSizeGuideContainerRef(ref);
            }
          }}
        ></StyledSizeGuideContainer>
      </StyledSizeGuideMenu>
    </>
  );
};

export default SizeGuideContainer;
